var render = function render(){var _vm=this,_c=_vm._self._c;return _c('List',_vm._l((_vm.items),function({ name, value }){return _c('ListItem',{key:value,attrs:{"component":"button"},on:{"click":function($event){_vm.localValue = value}}},[_c('ListItemTitle',[_vm._v(_vm._s(name))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }